const BASE_URL = "https://tombola.superball.site";

let csrfToken: string | null = null;

async function fetchCSRFToken(): Promise<string> {
  try {
    const response = await fetch(`${BASE_URL}/version101-refactor/public/api/auth.php`, {
      credentials: 'include'
    });
    const data = await response.json();
    if (!data.csrf_token) {
      throw new Error('No CSRF token received');
    }
    csrfToken = data.csrf_token;
    return csrfToken || "";
  } catch (error) {
    console.error("Failed to fetch CSRF token:", error);
    throw new Error("CSRF token request failed");
  }
}

async function ensureCSRFToken(): Promise<string> {
  return csrfToken ?? fetchCSRFToken();
}

async function requestWithCSRFRetry<T>(
  method: 'GET' | 'POST',
  path: string,
  data?: Record<string, any>,
  retry = true
): Promise<T> {
  try {
    const headers: Record<string, string> = {
      'Content-Type': 'application/x-www-form-urlencoded',
    };

    if (method === 'POST') {
      headers['X-CSRF-TOKEN'] = await ensureCSRFToken();
    }

    const formData = new URLSearchParams();
    if (data) {
      for (const key in data) {
        formData.append(key, data[key]);
      }
    }

    const response = await fetch(`${BASE_URL}${path}`, {
      method,
      headers,
      body: method === 'POST' ? formData.toString() : undefined,
      credentials: 'include'
    });

    if (response.status === 403 && retry) {
      await fetchCSRFToken();
      return requestWithCSRFRetry(method, path, data, false);
    }

    if (!response.ok) {
      const error = await response.json().catch(() => ({}));
      console.error(`${method} ${path} request failed:`, error);
      throw new Error(error.error || `${method} ${path} failed: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error(`${method} ${path} request failed:`, error);
    throw error;
  }
}

async function get<T>(path: string, params?: Record<string, string>): Promise<T> {
  const url = new URL(`${BASE_URL}${path}`);
  if (params) {
    for (const [key, value] of Object.entries(params)) {
      url.searchParams.append(key, value);
    }
  }
  return requestWithCSRFRetry('GET', url.pathname + url.search);
}

async function post<T>(path: string, data: Record<string, any>): Promise<T> {
  return requestWithCSRFRetry('POST', path, data);
}

// Sadece spesifik API fonksiyonları dışa aktarılıyor
export async function getGameState() {
  return get<{
    countdown: number;
    numbers: number[];
  }>("/version101-refactor/public/api/api.php?action=game-state");
}

export async function getBalance() {
  return get<{ balance: number }>("/version101-refactor/public/api/api.php?action=balance");
}

export async function login(username: string, password: string) {
  const token = await fetchCSRFToken();
  return post<{ status: "success" | "error", token: string }>("/version101-refactor/public/auth.php", {
    username,
    password,
    csrf_token: token
  });
}
